<template>
  <v-container fluid v-if="emailTemplate">
    <v-row>
      <v-col>
        <v-text-field :label="$t('admin_notification_template.email_subject')"
                      v-model="emailTemplate.email_subject"></v-text-field>
      </v-col>
    </v-row>
    <v-row class="pt-0">
      <v-col>
        <v-input hide-details>
          <v-container fluid class="flex-column">
            <legend class="v-label theme--light">{{ $t('admin_notification_template.email_content') }}</legend>
            <TinyMceEditor v-model="emailTemplate.email_content"></TinyMceEditor>
          </v-container>
        </v-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-checkbox :label="$t('admin_notification_template.push_notification_enabled')"
                    v-model="emailTemplate.push_notification_enabled">
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row v-if="emailTemplate.push_notification_enabled">
      <v-col>
        <v-text-field outlined
                      :rules="requiredRules"
                      :label="$t('admin_notification_template.push_notification_content')"
                      v-model="emailTemplate.push_notification_content"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field outlined
                      :label="$t('admin_notification_template.test_email')"
                      :placeholder="$t('admin_notification_template.recipient')"
                      v-model="testEmailRecipient">
          <template #append-outer>
            <v-tooltip top>
              <template #activator="{on, attrs}">
                <v-btn icon
                       v-on="on"
                       v-bind="attrs"
                       @click="sendTestEmail"
                       :disabled="!testEmailRecipient">
                  <v-icon>fas fa-paper-plane</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('admin_notification_template.send_email') }}</span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {computed, onMounted, ref, watch} from "@vue/composition-api";
import _ from "lodash";
import TinyMceEditor from "@/components/TinyMceEditor";

export default {
  name: 'SurveyEmailTemplate',
  components: {TinyMceEditor},
  props: {
    surveyId: String,
    changed: Boolean,
    save: Function,
    send: Function,
  },
  setup(props, {root, emit}) {
    onMounted(() => {
      getEmailTemplate();

      emit('update:save', saveEmailTemplate);
      emit('update:send', publishSurvey);
    })

    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const emailTemplate = ref({});
    const originalTemplate = ref(null);
    const getEmailTemplate = function () {
      root.$callAPI('hkiarace/admin/survey/email_template/', {
        survey_id: props.surveyId,
      }, function (response) {
        emailTemplate.value = {
          survey_id: props.surveyId,
          name: '',
          email_enabled: true,
          email_subject: '',
          email_content: '',
          push_notification_enabled: false,
          push_notification_content: '',
          ...response.body.template,
        };
        originalTemplate.value = {...emailTemplate.value};
      });
    }
    const templateChanged = computed(() => {
      return !_.isEqual(emailTemplate.value, originalTemplate.value);
    });
    watch(() => templateChanged.value, (newValue) => {
      emit('update:changed', newValue);
    }, {immediate: true});
    const testEmailRecipient = ref(null);
    const sendTestEmail = function () {
      root.$callAPI('event/email_template/test/', {
        subject: emailTemplate.value.email_subject,
        content: emailTemplate.value.email_content,
        recipient: testEmailRecipient.value,
      }, () => {
        root.$showAlertMessage('Email Sent');
      })
    };
    const saveEmailTemplate = function () {
      if (templateChanged.value) {
        root.$callAPI('hkiarace/admin/survey/email_template/set/', {
          ...emailTemplate.value,
          template_id: emailTemplate.value.id,
          survey_id: props.surveyId,
        }, (response) => {
          root.$showAlertMessage('Template Saved');
          getEmailTemplate();
        })
      }
    };
    const publishSurvey = function () {
      if (confirm(root.$t('admin_survey.confirm_publish_msg'))) {
        root.$callAPI('hkiarace/admin/survey/publish/', {
          survey_id: props.surveyId,
        })
      }
    }

    return {
      requiredRules,
      emailTemplate,
      templateChanged,
      testEmailRecipient,
      sendTestEmail,
      saveEmailTemplate,
    }
  },
}
</script>
